/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2023-10-15 13:36:33
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @LastEditTime: 2025-11-13 17:13:35
 */
/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2021-11-09 10:15:19
 * @LastEditors: WangQi
 * @LastEditTime: 2023-10-13 11:21:01
 */
// 采购结算管理
const map = {
  purchaseRefundOrderList: () =>
    import('@/views/purchaseSettlement/PurchaseRefundOrderList'), // 采购退货单列表
  createRefundOrder: () =>
    import('@/views/purchaseSettlement/components/RefundOrderDetail'), // 新建采购退货单
  editRefundOrder: () =>
    import('@/views/purchaseSettlement/components/RefundOrderDetail'), // 查看采购退货单明细
  pendingPurchaseOrderList: () =>
    import('@/views/purchaseSettlement/PendingPurchaseOrderList'), // 待录采购单列表
  purchaseOrderList: () =>
    import('@/views/purchaseSettlement/PurchaseOrderList'), // 采购单列表
  createPurchaseOrder: () =>
    import('@/views/purchaseSettlement/components/PendingPurchaseOrderDetail'), // 新建采购单
  CGInternalTransactionConfigDetail: () =>
    import('@/views/purchaseSettlement/components/CGInternalTransactionConfigDetail'), // 内部交易配置详情
  cgSupplyPriceApproveList: () =>
    import('@/views/purchaseSettlement/CgSupplyPriceApproveList'), // 采购供货价审批详情
  cgSupplyPriceList: () =>
    import('@/views/purchaseSettlement/CgSupplyPriceList'), // 采购供货价列表
  cgSupplyPriceApproveDetail: () =>
    import('@/views/purchaseSettlement/components/CgSupplyPriceApproveDetail'), // 采购供货价审批详情
  typingPurchaseOrder: () =>
    import('@/views/purchaseSettlement/components/PendingPurchaseOrderDetail'), // 录入采购单
  editPurchaseOrder: () =>
    import('@/views/purchaseSettlement/components/PendingPurchaseOrderDetail'), // 查看采购单
  purchaseStockinOrderList: () =>
    import('@/views/purchaseSettlement/PurchaseStockinOrderList'), // 采购入库列表
  editpurchaseStockinOrder: () =>
    import('@/views/purchaseSettlement/components/PurchaseStockinOrderDetail'), // 查看采购入库详情
  purchaseStockinOrderDetailList: () =>
    import('@/views/purchaseSettlement/PurchaseStockinOrderDetailList'), // 采购入库明细列表
  purchaseOrderDetailList: () =>
    import('@/views/purchaseSettlement/PurchaseOrderDetailList'), // 采购明细列表
  purchasePrepaymentOrderList: () =>
    import('@/views/purchaseSettlement/PurchasePrepaymentOrderList'), // 采购预付申请单列表
  createPurchasePrepayment: () =>
    import('@/views/purchaseSettlement/components/PurchasePrepaymentDetail'), // 新建采购预付申请单
  editPurchasePrepayment: () =>
    import('@/views/purchaseSettlement/components/PurchasePrepaymentDetail'), // 查看采购预付申请单
  purchaseCheckOrderList: () =>
    import('@/views/purchaseSettlement/PurchaseCheckOrderList'), // 采购对账单列表
  createPurchaseCheckOrder: () =>
    import('@/views/purchaseSettlement/components/PurchaseCheckOrderDetail'), // 新建采购对账单
  editPurchaseCheckOrder: () =>
    import('@/views/purchaseSettlement/components/PurchaseCheckOrderDetail'), // 查看采购对账单
  creditNoteList: () => import('@/views/purchaseSettlement/CreditNoteList'), // 供应商信用票列表
  createCreditNoteInfo: () =>
    import('@/views/purchaseSettlement/components/CreditNoteInfoDetail'), // 新建供应商信用票
  editCreditNoteInfo: () =>
    import('@/views/purchaseSettlement/components/CreditNoteInfoDetail'), // 查看供应商信用票
  creditChangeRecord: () =>
    import('@/views/purchaseSettlement/CreditChangeRecord'), // 供应商信用票使用流水列表
  purchaseSupplierGoodsList: () => import('@/views/purchaseSettlement/PurchaseSupplierGoodsList'), // 供应商货品
  purchaseApplyForOrderList: () => import('@/views/purchaseSettlement/PurchaseApplyForOrderList'), // 采购申请单列表
  purchaseApplyForOrderDetailList: () => import('@/views/purchaseSettlement/PurchaseApplyForOrderDetailList'), // 采购申请单明细列表
  createApplyForPurchaseOrder: () => import('@/views/purchaseSettlement/components/PurchaseApplyForOrderDetail'), // 新建采购申请单
  editApplyForPurchaseOrder: () => import('@/views/purchaseSettlement/components/PurchaseApplyForOrderDetail'), // 查看采购申请单
  annualPurchaseRequisition: () => import('@/views/purchaseSettlement/AnnualPurchaseRequisition'), // 年度采购申请
  newProductQuotation: () => import('@/views/purchaseSettlement/NewProductQuotation'), // 商品成本报价列表
  createNewProductQuotation: () => import('@/views/purchaseSettlement/components/NewProductQuotationDetail'), // 新建商品成本报价
  newProductQuotationDetail: () => import('@/views/purchaseSettlement/components/NewProductQuotationDetail'), // 商品成本报价详情
  purchaseArrivalInformation: () => import('@/views/purchaseSettlement/PurchaseArrivalInformation/list.vue'), // 到货单列表
  purchaseArrivalInformationDetail: () => import('@/views/purchaseSettlement/PurchaseArrivalInformation/detail.vue'), // 到货单详情
  getMrpProductionMaterialShortageList: () => import('@/views/purchaseSettlement/GetMrpProductionMaterialShortageList'), // MRP缺货列表
  mrpProductAnalysis: () => import('@/views/purchaseSettlement/MrpProductAnalysis'), // MRP生产分析
  getCurrencyStockMonitor: () => import('@/views/purchaseSettlement/GetCurrencyStockMonitor'), // 通货库存展望表
  getCurrencyPurchasePlanMonitor: () => import('@/views/purchaseSettlement/GetCurrencyPurchasePlanMonitor'), // 采购申请执行表
  newProductCostDetail: () => import('@/views/purchaseSettlement/NewProductCost/Detail'), // RFX新品成本详情
  newProductCostEdit: () => import('@/views/purchaseSettlement/NewProductCost/Detail'), // RFX新品成本编辑
  newProductCostV1_5: () => import('@/views/purchaseSettlement/NewProductCost/index'), // RFX新品成本列表v1.5
  ratingReport: () => import('@/views/purchaseSettlement/RatingReport/index') // 评级报告
}

export default map
